import "../styles/main.scss";

import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

let originalData = null;
let existingCategories = [];
const warOrigValues = ['Civil War', 'Spanish-American War', 'World War I', 'World War II', 'Korean Conflict', 'Vietnam War'];
const serviceOrigValues = ['American Expeditionary Forces', 'Illinois National Guard', 'US Air Force', 'US Air Force Reserve', 'US Air Service',
    'US Army', 'US Army Air Corps', 'US Army Air Forces', 'US Army Reserve', 'US Marine Corps', 'US Marine Corps Reserve', 'US Naval Reserve', 'US Navy', 'US Navy Reserve'];
const yearOfDeathOrigValues = ['1861', '1862', '1863', '1864', '1865', '1905', '1917', '1918', '1919', '1940', '1942', '1943', '1944', '1945', '1946', '1951', '1952', '1953', '1954', '1966',
    '1968', '1969', '1970', '1971', '1976', 'MIA'];
const ageAtDeathOrigValues = ['19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32',
    '33', '34', '37', '38', '40', '45', '47', '48', '57', 'MIA'];
const classYearOrigValues = ['1846', '1850', '1851', '1855', '1856', '1860', '1862', '1863', '1865', '1899', '1911', '1913', '1914', '1915', '1916', '1917', '1918', '1919', '1920', '1922', '1925', '1928', '1929',
    '1933', '1934', '1935', '1936', '1937', '1938', '1939', '1940', '1941', '1942', '1943', '1944', '1945', '1946',
    '1949', '1951', '1952', '1953', '1960', '1966', '1967', '1968', '1969', '1971'];
const majorOrigValues = ['Biology', 'Business Administration', 'Chemical Engineering', 'Chemistry', 'Classics', 'Economics', 'English', 'Geology',
    'Greek', 'History', 'Mathematics', 'Mining Engineering', 'Physics', 'Political Science', 'Psychology', 'Sociology', 'Spanish', 'Speech'];
const greekOrganizationOrigValues = ['Alpha Delta Epsilon', 'Beta Theta Pi', 'Lambda Chi Alpha', 'Sigma Nu', 'Tau Kappa Epsilon', 'Phi Gamma Delta',
    'Phi Delta Theta', 'Phi Sigma Kappa'];
const homeStateOrigValues = ['Georgia', 'Hawaii', 'Illinois', 'Indiana', 'Iowa', 'Massachusetts', 'Michigan', 'Minnesota', 'Missouri',
    'New York', 'Ohio', 'Pennsylvania', 'Tennessee', 'Texas', 'Wisconsin'];

let fieldNames = {};
fieldNames['Name'] = 'Name';
fieldNames['GivenNames'] = 'Known As';
fieldNames['KnownAs'] = 'Known As';
fieldNames['Surname'] = 'Surname';
fieldNames['Suffix'] = 'Suffix';
fieldNames['BirthDate'] = 'Birth Date';
fieldNames['BirthLocation'] = 'Birth Location';
fieldNames['Father'] = 'Father';
fieldNames['Mother'] = 'Mother';
fieldNames['Siblings'] = 'Siblings';
fieldNames['Spouse'] = 'Spouse';
fieldNames['Children'] = 'Children';
fieldNames['OtherFamily'] = 'Other Family';
fieldNames['HighSchool'] = 'High School';
fieldNames['HighSchoolLocation'] = 'High School Location';
fieldNames['HighSchoolActivities'] = 'High School Activities';
fieldNames['HomeTown'] = 'Hometown';
fieldNames['HomeState'] = 'Home State';
fieldNames['EnteredKnox'] = 'Entered Knox';
fieldNames['ClassYear'] = 'Class Year';
fieldNames['Major'] = 'Major';
fieldNames['Sports'] = 'Sports';
fieldNames['Honored'] = 'Honored';
fieldNames['Activities'] = 'Activities';
fieldNames['GreekOrganization'] = 'Fraternity';
fieldNames['EnlistmentDate'] = 'Enlistment Date';
fieldNames['EnlistmentLocation'] = 'Enlistment Location';
fieldNames['EnlistmentNumber'] = 'Enlistment Number';
fieldNames['War'] = 'War / Conflict';
fieldNames['Service'] = 'Military Service';
fieldNames['SerialNumber'] = 'Serial Number';
fieldNames['Rank'] = 'Rank';
fieldNames['Unit'] = 'Unit';
fieldNames['ServiceHistory'] = 'Service History';
fieldNames['Incident'] = 'Incident';
fieldNames['IncidentDate'] = 'Incident Date';
fieldNames['IncidentLocation'] = 'Incident Location';
fieldNames['CasualtyData'] = 'Casualty Data';
fieldNames['YearOfDeath'] = 'Year of Death';
fieldNames['DateOfDeath'] = 'Date of Death';
fieldNames['AgeAtDeath'] = 'Age at Death';
fieldNames['LocationOfDeath'] = 'Location of Death';
fieldNames['OriginallyBuried'] = 'Originally Buried';
fieldNames['Burial'] = 'Burial';
fieldNames['PlotLocation'] = 'Plot Location';
fieldNames['CivilianCenotaph'] = 'Civilian Cenotaph';
fieldNames['MilitaryCenotaph'] = 'Military Cenotaph';
fieldNames['Links'] = 'Links';
fieldNames['FindAGrave'] = 'Find a Grave';
fieldNames['Awards'] = 'Awards';
fieldNames['Citation'] = 'Citation';
fieldNames['Remarks'] = 'Remarks';
fieldNames['KnoxID'] = 'Knox ID';
fieldNames['LastUpdated'] = 'Last Updated';
fieldNames['Id'] = 'Id';

let selectedWar = 0;
let selectedService = 0;
let selectedYearOfDeath = 0;
let selectedAgeAtDeath = 0;
let selectedClassYear = 0;
let selectedMajor = 0;
let selectedGreekOrganization = 0;
let selectedHomeState = 0;

let photoURL = "https://www.knox.edu/watch/99photos/";

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

let appMode = params.mode;

let appUsedLast = new Date();
let appUsed = false;

function resetApplication() {
    const timeDiff = (new Date().getTime() - appUsedLast.getTime()) / 1000 / 60;

    if (appUsed && timeDiff > 10) document.location.reload(true);
}

if (appMode === 'kiosk') {
    setInterval(resetApplication, 5000);

    setTimeout(function () {
        window.scrollTo(0, 0);
    }, 3000);
}

function App({ initialData }) {
    const [data, setData] = React.useState(initialData);
    const [warValues, setWarValues] = React.useState(warOrigValues);
    const [serviceValues, setServiceValues] = React.useState(serviceOrigValues);
    const [ageAtDeathValues, setAgeAtDeathValues] = React.useState(ageAtDeathOrigValues);
    const [yearOfDeathValues, setYearOfDeathValues] = React.useState(yearOfDeathOrigValues);
    const [classYearValues, setClassYearValues] = React.useState(classYearOrigValues);
    const [majorValues, setMajorValues] = React.useState(majorOrigValues);
    const [greekOrganizationValues, setGreekOrganizationValues] = React.useState(greekOrganizationOrigValues);
    const [homeStateValues, setHomeStateValues] = React.useState(homeStateOrigValues);
    const [resultsViewState, setShowResult] = React.useState(false);
    const [searchViewState, setShowSearch] = React.useState(true);
    const [profileViewState, setShowProfile] = React.useState(false);
    const [aboutViewState, setShowAbout] = React.useState(false);
    const [noResultsViewState, setShowNoResults] = React.useState(false);
    const [selectedProfile, setSelectedProfile] = React.useState(null);
    const [searchValue, setSearchValue] = React.useState('none');
    const [textSearchValue, setTextSearchValue] = React.useState('');

    function clone(o) {
        return JSON.parse(JSON.stringify(o));
    }

    useEffect(() => {
        fetch('99Lives/GetData')
            .then((response) => response.json())
            .then((newData) => {
                originalData = clone(newData);
                setData(newData);

                applyFilter(existingCategories);
            });
    }, []);

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    function getLetters(names) {
        return names.map(n => n['Surname'].charAt(0)).filter(onlyUnique).sort();
    }

    function applyFilters(e) {
        const filterCategory = e.target.dataset.category;
        const filterValue = e.target.value;

        switch (filterCategory) {
            case 'War':
                selectedWar = filterValue;
                break;
            case 'Service':
                selectedService = filterValue;
                break;
            case 'YearOfDeath':
                selectedYearOfDeath = filterValue;
                break;
            case 'AgeAtDeath':
                selectedAgeAtDeath = filterValue;
                break;
            case 'ClassYear':
                selectedClassYear = filterValue;
                break;
            case 'Major':
                selectedMajor = filterValue;
                break;
            case 'GreekOrganization':
                selectedGreekOrganization = filterValue;
                break;
            case 'HomeState':
                selectedHomeState = filterValue;
                break;
        }

        //if ... remove from exisitng filters
        if (filterValue === "0") {
            existingCategories = existingCategories.filter(f => f[0] != filterCategory);
            if (existingCategories.length === 0) setData(originalData);
            else {
                const filteredData = getFilteredData(existingCategories);
                setData(filteredData);
            }

            applyFilter(existingCategories);
        } else {
            existingCategories = existingCategories.filter(ec => ec[0] != filterCategory);

            existingCategories.push([filterCategory, filterValue]);

            applyFilter(existingCategories);
            const filteredData = getFilteredData(existingCategories);
            setData(filteredData);
        }
    }

    function clearFilters() {
        selectedAgeAtDeath = 0;
        selectedClassYear = 0;
        selectedGreekOrganization = 0;
        selectedHomeState = 0;
        selectedMajor = 0;
        selectedService = 0;
        selectedWar = 0;
        selectedYearOfDeath = 0;

        existingCategories.length = 0;
        applyFilter(existingCategories);
        setData(originalData);

        appUsed = true;
        appUsedLast = new Date();
    }

    function getFilteredData(filteredCategories) {
        let filteredData = clone(originalData);
        filteredCategories.forEach(filter => {
            filteredData = filteredData.filter(d => {
                let found = false;
                const searchExp = new RegExp(filter[1] + '(\\s|,|$)', 'ig');
                if (d[filter[0]].search(searchExp) >= 0) found = true;

                return found;
            });

        });

        let sortedFilteredData = filteredData.sort((a, b) => {
            if (a['Surname'].toLowerCase() < b['Surname'].toLowerCase()) return -1;
            else if (a['Surname'].toLowerCase() > b['Surname'].toLowerCase()) return 1;
            else return 0;
        });

        return sortedFilteredData;
    }

    function applyFilter(filteredCategories) {
        filterCategoryValues('War', warOrigValues, setWarValues);
        filterCategoryValues('Service', serviceOrigValues, setServiceValues);
        filterCategoryValues('YearOfDeath', yearOfDeathOrigValues, setYearOfDeathValues);
        filterCategoryValues('AgeAtDeath', ageAtDeathOrigValues, setAgeAtDeathValues);
        filterCategoryValues('ClassYear', classYearOrigValues, setClassYearValues);
        filterCategoryValues('Major', majorOrigValues, setMajorValues);
        filterCategoryValues('GreekOrganization', greekOrganizationOrigValues, setGreekOrganizationValues);
        filterCategoryValues('HomeState', homeStateOrigValues, setHomeStateValues);
    }

    function filterCategoryValues(categoryName, originalCatData, setNewData) {
        var otherExisitingCategories = clone(existingCategories).filter(e => e[0] != categoryName);

        const filteredData = getFilteredData(otherExisitingCategories);

        let filteredValues = clone(originalCatData).filter(value => {
            let categoryValues = filteredData.map(n => n[categoryName]);
            let found = false;
            categoryValues.forEach(cValue => {
                const searchExp = new RegExp(value + '(\\s|,|$)', 'ig');
                if (cValue.search(searchExp) >= 0) found = true;
            });
            return found;
        });

        setNewData(filteredValues);
    }

    function showResults() {
        setShowResult(true);
        setShowSearch(false);
        setShowProfile(false);

        appUsed = true;
        appUsedLast = new Date();
    }

    function showSearch() {
        setShowResult(false);
        setShowProfile(false);
        setShowNoResults(false);
        setShowAbout(false);

        clearFilters();
        setTextSearchValue('');

        setShowSearch(true);

        appUsed = true;
        appUsedLast = new Date();
    }

    function showProfile(e) {
        const profileId = e.target.parentNode.dataset.rowid;
        const profile = clone(originalData).filter(d => d['Id'] == profileId)[0];
        setSelectedProfile(profile);

        setShowResult(false);
        setShowSearch(false);
        setShowProfile(true);

        appUsed = true;
        appUsedLast = new Date();
    }

    function searchByLastName(e) {
        const letter = e.target.dataset.letter;

        const results = clone(originalData).filter(d => d['Surname'].charAt(0) === letter).sort((a, b) => {
            if (a['Surname'].toLowerCase() < b['Surname'].toLowerCase()) return -1;
            else if (a['Surname'].toLowerCase() > b['Surname'].toLowerCase()) return 1;
            else return 0;
        });

        setData(results);

        showResults();

        appUsed = true;
        appUsedLast = new Date();
    }

    function showAboutInfo() {
        setShowAbout(true);
        setShowNoResults(false);
        setShowProfile(false);
        setShowResult(false);
        setShowSearch(false);
    }

    function handleLinkSearch(e) {
        e.preventDefault();

        const searchValue = e.target.innerHTML;
        searchAllAttributes(searchValue);

        appUsed = true;
        appUsedLast = new Date();
    }

    function handleLinkTextSearch(e) {
        e.preventDefault();

        const searchValue = e.target.dataset.searchtext;
        searchAllAttributes(searchValue);

        appUsed = true;
        appUsedLast = new Date();
    }

    function handleSearch(e) {
        searchAllAttributes(textSearchValue);

        appUsed = true;
        appUsedLast = new Date();
    }

    function searchKeyPress(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            searchAllAttributes(textSearchValue);

            appUsed = true;
            appUsedLast = new Date();
        }
    }

    function handleSearchTextChange(e) {
        setTextSearchValue(e.target.value);

        appUsed = true;
        appUsedLast = new Date();
    }

    function searchAllAttributes(searchValue) {
        searchValue = searchValue.toLowerCase();

        const results = clone(originalData).filter(row => row['Name'].toLowerCase().includes(searchValue) ||
            row['BirthDate'].toLowerCase().includes(searchValue) ||
            row['BirthLocation'].toLowerCase().includes(searchValue) ||
            row['HighSchool'].toLowerCase().includes(searchValue) ||
            row['HighSchoolLocation'].toLowerCase().includes(searchValue) ||
            row['HighSchoolActivities'].toLowerCase().includes(searchValue) ||
            row['HomeTown'].toLowerCase().includes(searchValue) ||
            row['HomeState'].toLowerCase().includes(searchValue) ||
            row['EnteredKnox'].toLowerCase().includes(searchValue) ||
            row['ClassYear'].toLowerCase().includes(searchValue) ||
            row['Major'].toLowerCase().includes(searchValue) ||
            row['Sports'].toLowerCase().includes(searchValue) ||
            row['Honored'].toLowerCase().includes(searchValue) ||
            row['Activities'].toLowerCase().includes(searchValue) ||
            row['GreekOrganization'].toLowerCase().includes(searchValue) ||
            row['EnlistmentDate'].toLowerCase().includes(searchValue) ||
            row['EnlistmentLocation'].toLowerCase().includes(searchValue) ||
            row['EnlistmentNumber'].toLowerCase().includes(searchValue) ||
            row['War'].toLowerCase().includes(searchValue) ||
            row['Service'].toLowerCase().includes(searchValue) ||
            row['SerialNumber'].toLowerCase().includes(searchValue) ||
            row['Rank'].toLowerCase().includes(searchValue) ||
            row['Unit'].toLowerCase().includes(searchValue) ||
            row['ServiceHistory'].toLowerCase().includes(searchValue) ||
            row['Incident'].toLowerCase().includes(searchValue) ||
            row['IncidentDate'].toLowerCase().includes(searchValue) ||
            row['IncidentLocation'].toLowerCase().includes(searchValue) ||
            row['CasualtyData'].toLowerCase().includes(searchValue) ||
            row['YearOfDeath'].toLowerCase().includes(searchValue) ||
            row['DateOfDeath'].toLowerCase().includes(searchValue) ||
            row['AgeAtDeath'].toLowerCase().includes(searchValue) ||
            row['LocationOfDeath'].toLowerCase().includes(searchValue) ||
            row['OriginallyBuried'].toLowerCase().includes(searchValue) ||
            row['Burial'].toLowerCase().includes(searchValue) ||
            row['PlotLocation'].toLowerCase().includes(searchValue) ||
            row['CivilianCenotaph'].toLowerCase().includes(searchValue) ||
            row['Links'].toLowerCase().includes(searchValue) ||
            row['FindAGrave'].toLowerCase().includes(searchValue) ||
            row['Awards'].toLowerCase().includes(searchValue) ||
            row['Citation'].toLowerCase().includes(searchValue) ||
            row['Remarks'].toLowerCase().includes(searchValue)
        ).sort((a, b) => {
            if (a['Surname'].toLowerCase() < b['Surname'].toLowerCase()) return -1;
            else if (a['Surname'].toLowerCase() > b['Surname'].toLowerCase()) return 1;
            else return 0;
        });

        if (results.length > 0) {
            setData(results);
            showResults();
        }
        else {
            setData(originalData);
            setSearchValue(searchValue);
            setShowResult(false);
            setShowSearch(false);
            setShowProfile(false);
            setShowNoResults(true);
        }

        appUsed = true;
        appUsedLast = new Date();
    }

    return (
        <>
            <section id="L99-hero">
                <header>
                    <div>
                        <img src="https://www.knox.edu/images/Other/99Lives/99LivesFinal.png" alt="99 Lives: The Knox College Gold Star Memorial Project" />
                    </div>
                    <p>
                        They shall grow not old, as we that are left grow old:<br />
                        Age shall not weary them, nor the years condemn.<br />
                        At the going down of the sun and in the morning<br />
                        We will remember them.<br />
                        <span>from "For the Fallen" &mdash; Laurence Binyon, September 1914</span>
                    </p>
                </header>
                <div>
                    <div>
                        <p>We salute the courage, sacrifice, and inspiration of these men of Knox College who perished while fighting for the cause of freedom.</p>
                        <p>Read about our veterans who earned a <a href="#" onClick={handleLinkSearch}>Silver Star</a>, were awarded <a href="#" onClick={handleLinkSearch}>Distinguished Service Cross</a> and <a href="#" onClick={handleLinkSearch}>Navy Cross</a>, and one veteran who had a <a href="#" onClick={handleLinkTextSearch} data-searchtext="FREDERICK THOMAS WEBER">ship named in his honor</a>.</p>
                    </div>
                    <div id="L99-rotator">
                        <div class="L99-rotator-photo"></div>
                        <div class="L99-rotator-photo"></div>
                        <div class="L99-rotator-photo"></div>
                        <div class="L99-rotator-photo"></div>
                    </div>
                </div>
            </section>
            {data.length === 0 ? (<div id="L99-loading-msg"><div class="container">
                <div class="wrapper">
                    <div class="loader">
                        <div class="dot"></div>
                    </div>
                    <div class="loader">
                        <div class="dot"></div>
                    </div>
                    <div class="loader">
                        <div class="dot"></div>
                    </div>
                    <div class="loader">
                        <div class="dot"></div>
                    </div>
                    <div class="loader">
                        <div class="dot"></div>
                    </div>
                    <div class="loader">
                        <div class="dot"></div>
                    </div>
                </div>
                <div class="text">
                    Please wait
                </div>
            </div></div>) : (
                <>
                    <div id="L99-search-area" style={{ display: searchViewState ? 'block' : 'none' }}>
                        <div>
                            <h2>Search by Last Name</h2>
                            {getLetters(originalData).map(letter => (
                                <button onClick={searchByLastName} data-letter={letter}>{letter}</button>
                            ))}
                        </div>
                        <div>
                            <h2>Search by Filter</h2>
                            <div>
                                <div>
                                    <div>
                                        <p>War / Conflict</p>
                                        <select onChange={applyFilters} data-category='War'>
                                            <option value="0">...</option>
                                            {warValues.map(value => (
                                                <option value={value} selected={value === selectedWar}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <p>Military Service</p>
                                        <select onChange={applyFilters} data-category='Service'>
                                            <option value="0">...</option>
                                            {serviceValues.map(value => (
                                                <option value={value} selected={value === selectedService}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <p>Year of Death</p>
                                        <select onChange={applyFilters} data-category='YearOfDeath'>
                                            <option value="0">...</option>
                                            {yearOfDeathValues.map(value => (
                                                <option value={value} selected={value === selectedYearOfDeath}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <p>Age at Death</p>
                                        <select onChange={applyFilters} data-category='AgeAtDeath'>
                                            <option value="0">...</option>
                                            {ageAtDeathValues.map(value => (
                                                <option value={value} selected={value === selectedAgeAtDeath}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <p>Class Year</p>
                                        <select onChange={applyFilters} data-category='ClassYear'>
                                            <option value="0">...</option>
                                            {classYearValues.map(value => (
                                                <option value={value} selected={value === selectedClassYear}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <p>Major</p>
                                        <select onChange={applyFilters} data-category='Major'>
                                            <option value="0">...</option>
                                            {majorValues.map(value => (
                                                <option value={value} selected={value === selectedMajor}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <p>Fraternity</p>
                                        <select onChange={applyFilters} data-category='GreekOrganization'>
                                            <option value="0">...</option>
                                            {greekOrganizationValues.map(value => (
                                                <option value={value} selected={value === selectedGreekOrganization}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <p>Home State</p>
                                        <select onChange={applyFilters} data-category='HomeState'>
                                            <option value="0">...</option>
                                            {homeStateValues.map(value => (
                                                <option value={value} selected={value === selectedHomeState}>{value}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button onClick={showResults}>Search with Filters</button>
                                <button onClick={clearFilters}>Clear Filters</button>
                            </div>
                        </div>
                        <div>
                            <h2>Search by Text</h2>
                            <input onKeyDown={searchKeyPress} onChange={handleSearchTextChange} value={textSearchValue} />
                            <button onClick={handleSearch}>Search</button>
                            <p>Suggested search terms: KIA, MIA, POW, Bataan, Silver Star, Bronze Star, Cross, rank, major course of study, specific sport or activity while at Knox College.</p>
                        </div>
                        <div style={{ textAlign: 'center' }}><a href="#L99-about" onClick={showAboutInfo} style={{ color: '#4F3276' }}> About 99 Lives</a></div>
                    </div>
                    <div id="L99-results" style={{ display: resultsViewState ? 'block' : 'none' }}>
                        <div><button onClick={showSearch}>Back to Search</button></div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>War/Conflict<br />
                                        <select onChange={applyFilters} data-category='War'>
                                            <option value="0">...</option>
                                            {warValues.map(value => (
                                                <option value={value} selected={value === selectedWar}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>Military Service<br />
                                        <select onChange={applyFilters} data-category='Service'>
                                            <option value="0">...</option>
                                            {serviceValues.map(value => (
                                                <option value={value} selected={value === selectedService}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>Year of Death<br />
                                        <select onChange={applyFilters} data-category='YearOfDeath'>
                                            <option value="0">...</option>
                                            {yearOfDeathValues.map(value => (
                                                <option value={value} selected={value === selectedYearOfDeath}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>Age at Death<br />
                                        <select onChange={applyFilters} data-category='AgeAtDeath'>
                                            <option value="0">...</option>
                                            {ageAtDeathValues.map(value => (
                                                <option value={value} selected={value === selectedAgeAtDeath}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>Class Year<br />
                                        <select onChange={applyFilters} data-category='ClassYear'>
                                            <option value="0">...</option>
                                            {classYearValues.map(value => (
                                                <option value={value} selected={value === selectedClassYear}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>Major<br />
                                        <select onChange={applyFilters} data-category='Major'>
                                            <option value="0">...</option>
                                            {majorValues.map(value => (
                                                <option value={value} selected={value === selectedMajor}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>Fraternity<br />
                                        <select onChange={applyFilters} data-category='GreekOrganization'>
                                            <option value="0">...</option>
                                            {greekOrganizationValues.map(value => (
                                                <option value={value} selected={value === selectedGreekOrganization}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                    <th>Home State<br />
                                        <select onChange={applyFilters} data-category='HomeState'>
                                            <option value="0">...</option>
                                            {homeStateValues.map(value => (
                                                <option value={value} selected={value === selectedHomeState}>{value}</option>
                                            ))}
                                        </select>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(row => (
                                    <tr data-rowid={row['Id']} onClick={showProfile}>
                                        <td>{row['Name']}</td>
                                        <td>{row['War']}</td>
                                        <td>{row['Service']}</td>
                                        <td>{row['YearOfDeath']}</td>
                                        <td>{row['AgeAtDeath']}</td>
                                        <td>{row['ClassYear']}</td>
                                        <td>{row['Major']}</td>
                                        <td>{row['GreekOrganization']}</td>
                                        <td>{row['HomeState']}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div id="L99-profile" style={{ display: profileViewState ? 'block' : 'none' }}>
                        <div>
                            <div><button onClick={showResults}>Return to Search Results</button></div>
                            <h1>{selectedProfile ? selectedProfile.Name : ''}</h1>
                            <div class="L99-profile-wrapper">
                                <div class="L99-photos">
                                    {selectedProfile ? selectedProfile['VeteranPhotos'].length > 0 ? selectedProfile['VeteranPhotos'].map((s, i) => {
                                        if (i === 0) {
                                            return (<a href={photoURL + selectedProfile['Surname'] + '/' + s.FileName} data-lightbox="l99-photos" data-title={s.FileDescription} className={"L99-photo--large"}><img src={photoURL + selectedProfile['Surname'] + '/' + s.FileName} alt={s.FileDescription} /></a>);
                                        } else {
                                            return (<a href={photoURL + selectedProfile['Surname'] + '/' + s.FileName} data-lightbox="l99-photos" data-title={s.FileDescription} className={"L99-photo"}><img src={photoURL + selectedProfile['Surname'] + '/' + s.FileName} alt={s.FileDescription} /></a>);
                                        }
                                    }) : (<div><p>No photos.</p></div>)
                                        : (<div><p>No profile selected.</p></div>)
                                    }
                                    <div class="L99-commentform" style={{ display: appMode === 'kiosk' ? 'none' : 'block' }} >
                                        <p>If you have updates for this or other veterans featured on this site, please use this form to contact us. Thank you.</p>
                                        <a href="https://form.asana.com/?k=WJwLJllWXDEejcZH0Ig0SQ&d=7752261144102" target="_blank">Send Us Updates</a>
                                    </div>
                                </div>
                                <div class="L99-profile-details">
                                    {selectedProfile ? Object.keys(selectedProfile).filter(k => selectedProfile[k] != "" && k != "Name" && k != "Surname" && k != "Photos" && k != "VeteranPhotos" && k != "KnoxID" && k != "LastUpdated" && k != "Id" && k != "YearOfDeath").map(key => {
                                        if (key === 'FindAGrave') {
                                            let graveLinks = selectedProfile[key].split(',');
                                            if (appMode !== 'kiosk') {
                                                return (
                                                    <div>
                                                        <h2>{fieldNames[key]}</h2>
                                                        <div className="L99-links-list">{graveLinks.map(url => (
                                                            <a href={'https://www.findagrave.com/memorial/' + url.trim()} target="_blank">{'https://www.findagrave.com/memorial/' + url.trim()}</a>
                                                        )
                                                        )}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        } else if (key === 'Links') {
                                            let links = selectedProfile[key].split(',');
                                            if (appMode !== 'kiosk') {
                                                return (
                                                    <div>
                                                        <h2>{fieldNames[key]}</h2>
                                                        <div className="L99-links-list">{links.map(url => (
                                                            <a href={url.trim()} target="_blank">{url.trim()}</a>
                                                        )
                                                        )}
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        } else {
                                            return (
                                                <div>
                                                    <h2>{fieldNames[key]}</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: selectedProfile[key] }} />
                                                </div>
                                            );
                                        }
                                    }) : (<div><p>No profile selected.</p></div>)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="L99-no-results" style={{ display: noResultsViewState ? 'block' : 'none' }}><p>No search results for {searchValue}.</p><button onClick={showSearch}>Back to Search</button></div>
                    <div id="L99-about" style={{ display: aboutViewState ? 'block' : 'none', lineHeight: 1.3 }}>
                        <p><button href="#Home" onClick={showSearch}>Return Home</button></p>
                        <p>The memorial was begun by James L. Bjorkman ’57 in an effort to answer his own question, “Who were
                            these guys?” It has grown to honor veterans affiliated with Knox College (Galesburg, Illinois, USA) who
                            gave their lives in service to our nation.</p>
                        <p>Its name is taken from the Gold Star program, begun during World War I. Relatives of those serving in
                            the United States armed forces displayed banners with blue stars. A gold star banner represented a
                            family member who died in service.</p>
                        <p>In 2016, Bjorkman began research in the Knox College Special Collections and Archives. He worked
                            directly with students Sarah Pawlicki ’17 and Ben Hosto ’18. Assisting were Curator of College Archives
                            Carley Robison, Special Collections Supervisor Kay Vander Meulen, Associate Librarian for Digital
                            Initiatives and Collections Laurie Sauer, Senior Archives Assistant Maryjo McCarthy McAndrew, and
                            Director of Seymour Library Jeff Douglas.</p>
                        <p>A temporary exhibit displayed in 2018 at Ford Center for the Fine Arts included photos and short profiles
                            of 99 veterans who died in World War I and World War II. Further research revealed more veterans and
                            additional information about their lives and service, leading to a decision to create a permanent online
                            exhibit, one expanded to include those who died in Korea and Vietnam, and to include those listed as
                            Missing In Action.</p>
                        <p>Several Knox College alumni were involved in research, development, and implementation. They
                            included John Cooke ’52, who died while the project was in development, database developer Howell
                            ‘Chip’ Evans ’68, former Registrar and Professor Emeritus of Physics Chuck Schulz ’72, researcher
                            Wendy Scherwat Ducourneau ’72, artist Casey Kremer ’73, and historian Rex Cherrington ’73.</p>
                        <p>College staff who lent their assistance included Chief Information Officer James Stevens, Assistant
                            Registrar Jamie Wollrab, Associate Director Alumni and Constituent Programs Megan Clayton, Assistant
                            Librarian for Special Collections and Archives Joseph Taylor, Director of Seymour Library Anne
                            Thomason, and Vice President for Advancement Monica Keith.</p>
                        <p>Since 2018, the memorial has been greatly expanded through extensive research by Wendy Scherwat
                            Ducourneau. Her research encompassed military records obtained by Freedom Of Information Act
                            requests from National Archives and Records Administration, military unit rosters, United States census
                            data, the Coffelt database, genealogy websites, fraternity records, high school and college yearbooks,
                            and memorials on Find A Grave.com. The memorial now includes Knox veterans who died serving in the
                            Civil War and the Spanish-American War.</p>
                        <p>The fully multi-media implementation of the memorial was unveiled at Knox College on May 13, 2022,
                            exactly 71 years to the day from the dedication of Memorial Gymnasium, itself built in remembrance of
                            those sons of Knox who died serving in World War II. Remarks by Bjorkman, Evans, and Scherwat
                            Ducourneau were followed by an invitation for attendees to search the database via a free-standing digital
                            kiosk in the lobby of Memorial Gymnasium.</p>
                        <p>A memorial paver has been placed at the National World War II Museum in New Orleans, Louisiana in
                            honor and in memory of these Knox veterans who gave their lives in the service of our country.</p>
                        <p><button href="#Home" onClick={showSearch}>Return Home</button></p>
                    </div>
                </>
            )
            }
        </>
    );
}

const root = createRoot(document.getElementById('root'));

root.render(
    <App initialData={[]} />
);